import { render, staticRenderFns } from "./publicList.vue?vue&type=template&id=37d381c2&scoped=true"
import script from "./publicList.vue?vue&type=script&lang=js"
export * from "./publicList.vue?vue&type=script&lang=js"
import style0 from "./publicList.vue?vue&type=style&index=0&id=37d381c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d381c2",
  null
  
)

export default component.exports